<template>
  <v-app id="app">
    <NavBar style="font-family: kalam" toggleDrawer />
    <v-sheet id="app-content">
      <v-main class="overflow-hidden">
        <!-- the view to be shown in this component  -->
        <router-view></router-view>
      </v-main>
    </v-sheet>
    <Footer style="font-family: kalam" />
  </v-app>
</template>

<script>
import NavBar from "./components/NavBar.vue";
import Footer from "./components/Footer.vue";

export default {
  components: { NavBar, Footer },

  data() {
    return {};
  }
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif, "Kalam", cursive;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

a {
  text-decoration: none;
}
</style>
